// extracted by mini-css-extract-plugin
export default {"addressAction":"V7-z","loading":"W7-z"};